import { render, staticRenderFns } from "./ServiceLeaveRecord.vue?vue&type=template&id=671f7606&scoped=true"
import script from "./ServiceLeaveRecord.vue?vue&type=script&lang=js"
export * from "./ServiceLeaveRecord.vue?vue&type=script&lang=js"
import style0 from "./ServiceLeaveRecord.vue?vue&type=style&index=0&id=671f7606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f7606",
  null
  
)

export default component.exports